import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Alert, AlertTitle} from '@material-ui/lab';
import {isObject} from 'utils/objects';
import {P} from './TypographyShortcuts';

const Message = ({message}) => {
    if (isObject(message)) {
        const {endpoint, message: messageBody, ...rest} = message;
        return (
            <>
                {endpoint && <P>endpoint: {endpoint}</P>}
                {messageBody && (
                    <>
                        <P>message:</P>
                        <pre>{JSON.stringify(messageBody, null, 2)}</pre>
                    </>
                )}
                {rest.length > 0 && (
                    <>
                        <P>other:</P>
                        <pre>{JSON.stringify(rest, null, 2)}</pre>
                    </>
                )}
            </>
        );
    } else {
        return <P>{message}</P>;
    }
};

export default function AlertDialog({
    title,
    message,
    severity = null,
    startOpen = true,
    buttonHidden = true,
    actions = null,
}) {
    const [open, setOpen] = useState(startOpen);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {!buttonHidden && (
                <Button
                    variant='outlined'
                    color='primary'
                    onClick={handleClickOpen}
                >
                    Message waiting - click to open
                </Button>
            )}
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                {title && (
                    <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
                )}
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        {severity ? (
                            <Alert severity={severity}>
                                <AlertTitle
                                    style={{textTransform: 'uppercase'}}
                                >
                                    {severity}
                                </AlertTitle>
                                <Message message={message} />
                            </Alert>
                        ) : (
                            <Message message={message} />
                        )}
                    </DialogContentText>
                </DialogContent>
                {actions && (
                    <DialogActions>
                        {actions?.map(action => (
                            <Button
                                onClick={action.handleClick}
                                color='primary'
                            >
                                {action.label}
                            </Button>
                        ))}
                    </DialogActions>
                )}
            </Dialog>
        </div>
    );
}
